module.exports = __webpack_public_path__ + "static/4-d64c5e187898a418d4fcd089adc5eeda.jpg";